import { render, staticRenderFns } from "./the-footer.vue?vue&type=template&id=d436745a&scoped=true"
import script from "./the-footer.vue?vue&type=script&lang=js"
export * from "./the-footer.vue?vue&type=script&lang=js"
import style0 from "./the-footer.vue?vue&type=style&index=0&id=d436745a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d436745a",
  null
  
)

export default component.exports